export const Url = {
  Server:
    process.env.NODE_ENV === "production"
      ? typeof process.env["REACT_APP_HOST"] === "string"
        ? `https://${process.env["REACT_APP_HOST"]}`
        : ""
      : "",
  // WebSocketsServer:
  //   process.env.NODE_ENV === "production"
  //     ? typeof process.env["REACT_APP_HOST"] === "string"
  //       ? `wss://${process.env["REACT_APP_HOST"]}/api/websockets`
  //       : `wss://${window.location.host}/api/websockets`
  //     : `wss://${process.env["REACT_APP_HOST"]}/api/websockets`,
  TokenServer:
    "https://aggapi-auth.ap.avlab.dev/auth/realms/vp-sechenov/protocol/openid-connect/token",
  UserInfo:
    "https://aggapi-auth.ap.avlab.dev/auth/realms/vp-sechenov/protocol/openid-connect/userinfo",
};
